const read = (k, def = '') => {
  const v = process.env[k];
  return v && v.trim() !== '' ? v.trim() : def;
};

const safeAtob = v => {
  try { return v ? atob(v) : ''; } catch { return ''; }
};

const clientPass = window.ENVIRONMENT && window.ENVIRONMENT === "PROD" ? 'REACT_APP_API_CLIENT_PASS_FE' : 'REACT_APP_API_CLIENT_PASS_DEV_FE';

export const API_BASE_URL = window.APP_DEFAULT_HOST + window.API_BASE_CONTEXT;
export const PATH_PROFESSIONS = process.env.REACT_APP_API_PROFESSIONS;
export const PATH_OCCUPATIONS = process.env.REACT_APP_API_OCCUPATIONS;
export const PATH_PROVINCES = process.env.REACT_APP_API_PROVINCES;
export const PATH_CANTONS = process.env.REACT_APP_API_CANTONS;
export const PATH_DISTRICT = process.env.REACT_APP_API_DISTRICT;
export const PATH_NEIGHBORHOODS = process.env.REACT_APP_API_NEIGHBORHOODS;
export const PATH_DOCUMENTS = process.env.REACT_APP_API_DOCUMENTS;
export const PATH_EDUCATIONS = process.env.REACT_APP_API_EDUCATIONS
export const PATH_MARITAL = process.env.REACT_APP_API_MARITAL
export const PATH_ACCOUNTS_BY_CIF_BANK = process.env.REACT_APP_API_ACCOUNTS
export const PATH_VALIDATE_OTP = process.env.REACT_APP_API_VALIDATE_OTP
export const PATH_GET_MANAGER_BY_ID_TRANSACTION = process.env.REACT_APP_API_GET_VALIDATE_TRANSACTION_ID;
export const PATH_GET_MANAGER_BY_ID_TRANSACTION_AND_OTP_VALID = process.env.REACT_APP_API_GET_VALIDATE_TRANSACTION_ID_AND_OTP_VALID;
export const PATH_PARAMETERS =  process.env.REACT_APP_API_PARAMETERS;
export const API_URL_GATEWAY = process.env.REACT_APP_API_URL_GATEWAY;
export const CLIENT_ID = read('REACT_APP_API_CLIENT_FE');
export const CLIENT_SECRET = safeAtob(read(clientPass));
export const PATH_GET_USERDATA_BY_ID_TRANSACTION = process.env.REACT_APP_API_PATH_GET_USERDATA_BY_ID_TRANSACTION;
export const PATH_POST_USERDATA = process.env.REACT_APP_API_PATH_POST_USERDATA_SAVE;
export const PATH_COMMERCE_ACTIVITY = process.env.REACT_APP_API_COMMERCE_ACTIVITY;
